import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { SecondaryTextButton } from '@bibliocommons/base-buttons';

import { selectOtherLanguageTitlesForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import ModalActions from 'app/actions/ModalActions';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import { OTHER_LANGUAGES_MODAL } from 'app/constants/BibConstants';
import OtherLanguagesModal from './OtherLanguagesModal';

import './OtherLanguagesButton.scss';

export default function OtherLanguagesButton() {
  const otherLanguageTitles = useSelector(selectOtherLanguageTitlesForCurrentBib);
  const dispatch = useDispatch();
  const handleClose = () => dispatch(ModalActions.closeModal(OTHER_LANGUAGES_MODAL));

  return otherLanguageTitles.size ? (
    <div className="cp-other-languages-button">
      <SecondaryTextButton
        handleClick={() => dispatch(ModalActions.openModal(OTHER_LANGUAGES_MODAL, { authRequired: false }))}
        className="other-languages-button"
        dataKey="other-languages-button"
      >
        <FormattedMessage id="other_languages_count" values={{ count: otherLanguageTitles.size }} />
      </SecondaryTextButton>
      <ModalContainer modalKey={OTHER_LANGUAGES_MODAL} handleClose={handleClose} size="small">
        <OtherLanguagesModal otherLanguageTitles={otherLanguageTitles} />
      </ModalContainer>
    </div>
  ) : null;
}
